// resultUi/SpotItems.js
export class SpotItems {
  constructor({ app, node }) {
    this.app = app;
    this.node = node;
    this.store = app.store;
    this.wayTable = this.store.config.wayTable;
  }

  getTags() {
    // ★ mixInfo が undefined の瞬間でも絶対に落ちないようにする
    const mixInfo = this.app.getState('mixInfo');
    const infos = mixInfo?.plan_infos || []; // ← ここが最重要

    // 何もなければ空文字で返す
    if (!infos.length) {
      return '';
    }

    let tags = '';

    infos.forEach((info, i) => {
      switch (i) {
        case 0:
          tags += this.getStartItemTags(info);
          break;

        case infos.length - 1:
          tags += this.getEndItemTags(info);
          break;

        default:
          tags += this.getNormalItemTags(info, i);
          break;
      }
    });

    return tags;
  }

  getStartItemTags(info) {
    let tags = '';
    tags += `
    <div class="flex gap-6 w-full">
      <div class="shrink-0 bg-linear-to-b from-gray to-gray bg-top bg-size-[2px_2px] bg-repeat-y pb-10 lg:pb-14">
        <p class="grid place-items-center w-[clamp(80px,7.81vw,100px)] aspect-square bg-green-300 rounded-full text-white text-[clamp(16px,1.41vw,18px)] font-bold uppercase">start</p>
      </div>
      <div class="flex-1 pb-10 lg:pb-14">
        <p class="font-bold text-[clamp(20px,1.875vw,24px)]">${info.title}</p>
      </div>
    </div>
    <div class="flex items-center gap-6 w-full">
      <div class="shrink-0 w-[clamp(80px,7.81vw,100px)] bg-linear-to-b from-gray to-gray bg-top bg-size-[2px_2px] bg-repeat-y pb-10 lg:pb-14">
        <div class="grid place-items-center w-12 mx-auto p-3 bg-gray-200 text-green aspect-square rounded-full" aria-hidden="true">${this.wayTable[info.route_info.way].nameByFa}</div>
      </div>
      <div class="flex-1 text-[clamp(16px,1.41vw,18px)] font-bold pb-10 lg:pb-14">${this.app.I18n('about')}${info.route_info.time}${this.app.I18n('minute')}</div>
    </div>`;
    return tags;
  }

  getNormalItemTags(info, index) {
    let tags = '';
    tags += `
    <div class="flex gap-6 w-full" id="disp_spot${index}">
      <div class="shrink-0 w-[clamp(80px,7.81vw,100px)] bg-linear-to-b from-gray to-gray bg-top bg-size-[2px_2px] bg-repeat-y pb-10 lg:pb-14">
        <p class="grid place-items-center w-16 mx-auto aspect-square border border-gray rounded-full bg-white text-green text-2xl font-bold">${index}</p>
      </div>
      <div class="flex-1 pb-10 lg:pb-14">
        <div class="lg:flex lg:gap-8 w-full">
          <div class="lg:flex-1">
            <div class="bg-gray-100 aspect-3/2 rounded-lg overflow-hidden relative">
              <img src="${info.pic_path}" alt="${info.title}" class="absolute top-0 left-[50%] translate-x-[-50%] w-auto h-full" loading="lazy">
            </div>
          </div>
          <div class="mt-4 lg:mt-0 lg:flex-1">
            <p class="text-green-300 font-bold text-[clamp(16px,1.41vw,18px)]">${info.arrival_time}〜${info.departure_time} (${info.stay_time}${this.app.I18n('minute')})</p>
            <p class="font-bold text-[clamp(18px,1.72vw,22px)]">${info.title}</p>
            <div class="leading-[1.75]">
              ${info.description}
            </div>
            <div class="max-w-[280px] mx-auto">
              <a href="${info.permalink}" class="relative block group w-full bg-white border border-black rounded-4xl mt-6 pl-4 py-3 pr-8 text-center font-bold" target="_blank">
                ${this.app.I18n('detailView')}
                <span class="absolute top-1/2 right-4 w-[1em] -mt-[0.5em] leading-none transform transition-transform duration-300 group-hover:translate-x-1">
                  <svg xmlns="http://www.w3.org/2000/svg" class="svg-icon" viewBox="0 0 640 640"><path fill="currentColor" d="M471.1 297.4C483.6 309.9 483.6 330.2 471.1 342.7L279.1 534.7C266.6 547.2 246.3 547.2 233.8 534.7C221.3 522.2 221.3 501.9 233.8 489.4L403.2 320L233.9 150.6C221.4 138.1 221.4 117.8 233.9 105.3C246.4 92.8 266.7 92.8 279.2 105.3L471.2 297.3z"/></svg>
                </span>
              </a>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="flex items-center gap-6 w-full">
      <div class="shrink-0 w-[clamp(80px,7.81vw,100px)] bg-linear-to-b from-gray to-gray bg-top bg-size-[2px_2px] bg-repeat-y pb-10 lg:pb-14">
        <div class="grid place-items-center w-12 mx-auto p-3 bg-gray-200 text-green aspect-square rounded-full" aria-hidden="true">${this.wayTable[info.route_info.way].nameByFa}</div>
      </div>
      <div class="relative flex-1 text-[clamp(16px,1.41vw,18px)] font-bold pb-10 lg:pb-14 before:absolute before:top-[0.5lh] before:right-[calc(100%+8px)] before:w-[calc((clamp(80px,7.81vw,100px)-48px)/2+12px)] before:h-[1px] before:bg-gray before:content-['']">${this.app.I18n('about')}${info.route_info.time}${this.app.I18n('minute')}</div>
    </div>`;
    return tags;
  }

  getEndItemTags(info) {
    let tags = '';
    tags += `
    <div class="flex gap-6 w-full">
      <div class="shrink-0">
        <p class="grid place-items-center w-[clamp(80px,7.81vw,100px)] aspect-square bg-green-300 rounded-full text-white text-[clamp(16px,1.41vw,18px)] font-bold uppercase">goal</p>
      </div>
      <div class="flex-1">
        <div class="lg:flex lg:gap-8 w-full pb-10 lg:pb-14">
          <div class="lg:flex-1">
            <div class="bg-gray-100 aspect-3/2 rounded-lg overflow-hidden relative">
              <img src="${info.pic_path}" alt="${info.title}" class="absolute top-0 left-[50%] translate-x-[-50%] w-auto h-full" loading="lazy">
            </div>
          </div>
          <div class="mt-4 lg:mt-0 lg:flex-1">
            <p class="text-green-300 font-bold text-[clamp(20px,1.875vw,24px)]">${info.arrival_time}〜${info.departure_time} (${info.stay_time}${this.app.I18n('minute')})</p>
            <p class="font-bold text-[clamp(20px,1.875vw,24px)]">${info.title}</p>
            <div class="leading-[1.75]">
              ${info.description}
            </div>
          </div>
        </div>
      </div>
    </div>`;
    return tags;
  }

  render() {
    this.node.innerHTML = '';

    const isFetching = this.app.getState('isFetching');
    const hasData = this.app.getState('hasValidSpotData') === true;

    // fetch終了かつ有効なスポット情報があれば
    if (!isFetching && hasData) {
      this.node.innerHTML = this.getTags();
    }
  }
}
